import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { CalendarDays, MousePointerClick, ShoppingCart } from "lucide-react";
import { PageLayout } from "~/components/page-layout";
import { EmptyState } from "~/components/ui/empty-state";
import { trpc } from "~/lib/trpc";
import { AddConversionButton } from "~/routes/(app)/conversions/-components/add-conversion-button";
import { ConversionsTable } from "~/routes/(app)/conversions/-components/conversions-table";

export const Route = createFileRoute("/(app)/conversions/")({
  component: RouteComponent,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(
      trpc.conversionRules.getAll.queryOptions(),
    );

    return {
      crumb: {
        label: "Conversion Goals",
        options: [],
        id: "conversions",
      },
    };
  },
});

function RouteComponent() {
  const { data } = useSuspenseQuery(trpc.conversionRules.getAll.queryOptions());

  return (
    <>
      {data.length > 0 && (
        <PageLayout.Header className="w-full flex justify-end items-center">
          <AddConversionButton />
        </PageLayout.Header>
      )}

      <PageLayout.Main>
        <div className="w-full h-full flex flex-col">
          {data.length === 0 ? (
            <div className="mx-auto max-w-2xl my-auto">
              <EmptyState
                title="Start tracking conversions!"
                description="Conversion goals help you track how well your page variants are performing."
                icons={[
                  () => <ShoppingCart className="text-stone-400" />,
                  () => <MousePointerClick className="text-blue-500" />,
                  () => <CalendarDays className="text-pink-500" />,
                ]}
                action={<AddConversionButton emptyState />}
              />
            </div>
          ) : (
            <div className="max-w-screen-lg mx-auto">
              <ConversionsTable data={data} />
            </div>
          )}
        </div>
      </PageLayout.Main>
    </>
  );
}
